import { Link } from 'react-router-dom'

import { Seo } from '../shared/lib/seo'

export function NotFoundPage() {
  return (
    <main className="flex min-h-0 flex-1 items-center justify-center bg-slate-50 px-4 py-10">
      <Seo title="Stran ni bila najdena" description="Iskana stran na Fukodromu ne obstaja več ali še ni objavljena." path="/404" noindex />
      <div className="max-w-lg rounded-[32px] border border-slate-200 bg-white p-8 text-center shadow-sm">
        <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-emerald-700">404</p>
        <h1 className="mt-2 text-3xl font-semibold tracking-tight text-slate-900">Ta lokacija ne obstaja.</h1>
        <p className="mt-3 text-sm leading-7 text-slate-600">
          Morda je bila odstranjena, preimenovana ali še ni objavljena. Vrni se na zemljevid in nadaljuj z raziskovanjem.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex rounded-full bg-emerald-700 px-5 py-3 text-sm font-semibold text-white transition hover:bg-emerald-800"
        >
          Nazaj na zemljevid
        </Link>
      </div>
    </main>
  )
}
